import React from 'react'
import BrowserLink from '../../../../../components/BrowserLink'
import StartButton from '../StartButton'
import * as cl from './HowManyOfThemButton.module.css'

const HowManyOfThemButton = ({link = '/'}) => {
  return (
    <div className={cl.wrapper}>
      <div className={cl.when_hover}>
        <StartButton link={link} title='Retake' />
      </div>

      <BrowserLink href={link} className={cl.link}>
        <span className={cl.how_many}>19</span>
        <span className={cl.separator}>/</span>
        <span className={cl.them}>50</span>
      </BrowserLink>
    </div>
  )
}

export default HowManyOfThemButton